export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px] md:min-h-[560px]">
      <div className="w-full lg:w-1/2 relative h-[300px] lg:h-auto overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20unboxing%20flat%20lay%20with%20a%20pair%20of%20crisp%20white%20sneakers%2C%20folded%20denim%20jeans%2C%20and%20branded%20tissue%20paper%20on%20a%20light%20birch%20wood%20floor%2C%20soft%20morning%20sunlight%20streaming%20in%2C%20lifestyle%20editorial%20photography%2C%20fresh%20and%20clean%20aesthetic%20with%20cool%20whites%20and%20warm%20wood%20tones&width=1200&height=900&seq=cta-lifestyle-v3&orientation=landscape"
          alt="CSSBuy Spreadsheet Shopping Guide"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
        <span className="absolute top-6 left-6 text-background-50/80 text-xs tracking-[0.2em] uppercase font-medium">
          2026 Guide
        </span>
        <div className="absolute bottom-6 left-6">
          <p className="font-heading text-2xl md:text-3xl lg:text-4xl text-background-50 font-bold leading-tight">
            The Ultimate<br />
            Spreadsheet<br />
            Shopping Method
          </p>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex items-center justify-center bg-background-50 px-8 py-12 lg:p-16">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-bold leading-tight mb-4">
            Ready to Start<br />Finding Deals?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-sm mx-auto">
            Access the most comprehensive CSSBuy spreadsheet collection with thousands of verified fashion finds. Updated daily with fresh drops across all major shopping agents.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}